import Vue from 'vue';
import TruffleContract from 'truffle-contract';
import CardOwnership from '../../build/contracts/CardOwnership.json';
import normalizeData from '../util/normalizeData';
import { transformDna } from '../util/transformDna';
import { battleLogic } from "../util/battleLogic";

export default {

    // NEW

    setGame (state, payload) {
        
        let game;
        
        if (state.games) {
            
            for (let i = 0; i < state.games.length; i++) {
                if (state.games[i].id == payload.id) {
                    game = state.games[i];
                }
            }
            
        }

        state.game = game;

    },

    setGames (state, payload) {
        
        state.games = payload.items;

    },

    addToGames (state, payload) {

        state.games.push(payload.item);

    },

    updateGame (state, payload) {

        const game = payload.item;
        state.game = game;

        for (let i = 0; i < state.games.length; i++) {

            if (state.games[i].id == game.id) {
                state.games[i] = game;
                break;
            }

        }
        
    },

    // ******* \\
    // GENERAL \\
    // ******* \\

    setModalType (state, payload) {
        state.modalType = payload;
    },
    
    updateLoading (state, payload) {
        state.loading = payload.loading;
    },

    updateContentLoading (state, payload) {
        state.contentLoading = payload.loading;
    },
    
    updatePendingTransaction (state, payload) {
        state.pendingTransaction = payload.status;
    },
    
    updateHasExtension (state, payload) {
        state.hasExtension = payload.hasExtension;
    },

    setHasError (state, payload) {
        state.hasError = payload.error;
    },

    setLocale (state, payload) {
        
        const locale = payload.locale;

        Vue.localStorage.set('locale', locale);
        state.locale = locale;

    },

    restoreLocale (state, payload) {
        const locale = Vue.localStorage.get('locale');

        if (locale) {
            state.locale = locale;
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/store/mutations.js